import http from '../http-common'

class CustomerService {
  async eligibility(
    docType,
    customerId,
    countryCode,
    noOfSimCount,
    msisdn = null
  ) {
    const response = await http.post(
      `/customers/eligibility`,
      {
        docType,
        customerId,
        countryCode: docType === 'PASSPORT' ? countryCode : 'SGP',
        noOfSimCount,
        msisdn,
      },
      { timeout: 10000 }
    )
    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }

  async eligibilityResult(transactionId, lastUpdate = false) {
    const response = await http.get(
      `/customers/eligibilityResult/${transactionId}?lastUpdate=${lastUpdate}`,
      { timeout: 10000 }
    )
    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }

  async postDocMismatch(idType, idNo, idNoInput, fullName, dob, ctryCode) {
    const response = await http.post(
      `/customers/doc/mismatch`,
      {
        idType,
        idNo,
        idNoInput,
        fullName,
        dob,
        ctryCode,
      },
      { timeout: 10000 }
    )
    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }

  async postDocTampered(idType, idNo, fullName, dob, ctryCode) {
    const response = await http.post(
      `/customers/doc/tampered`,
      {
        idType,
        idNo,
        fullName,
        dob,
        ctryCode,
      },
      { timeout: 10000 }
    )
    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }

  async validateFraud(idType, idNo, name, dob, ctryCode) {
    const response = await http.post(
      `/customers/validate`,
      {
        idType,
        idNo,
        name,
        dob,
        ctryCode,
      },
      { timeout: 10000 }
    )

    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }

  async workpassCheck(idNo) {
    const response = await http.get(`/customers/workpasscheck?idNo=${idNo}`, {
      timeout: 10000,
    })

    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }
}

export default new CustomerService()
